import React from "react";
import { Button, Card, Col, Form, Image, Input, Row } from "antd";
import { Link } from "react-router-dom";
import CONSTANTS, { loginRoot } from "../../../util/constant/CONSTANTS";
import { MailOutlined } from "@ant-design/icons";
import logo from "../../../asset/logos/icon.svg";
import useHttp from "../../../hooks/use-http";

const ForgetPass = () => {

  const API = useHttp();

  const [form] = Form.useForm();
  const validateLogin = (value) => {
    const payload = {
      email: value.email,
    };
    API.sendRequest(
      CONSTANTS.API.forget_password,
      (res) => {
        window.setTimeout(() => {
          window.location.assign(loginRoot);
          form.resetFields();
        }, 700)
      },
      payload,
      "Reset Password Link Sent to your Email"
    );
  };

  return (
    <>

      <div
        className="h-screen flex justify-center  items-center"

      >
        <Row className="">
          <Col span={10} sm={24} xs={24} md={10} lg={10}>
            <div className="mr-10  flex content-center justify-center">
              <Image
                src={logo}
                alt="Bash"
                preview={false}
                width={300}
                className="p-5"
              />
            </div>
          </Col>
          <Col span={14} sm={24} xs={24} md={14} lg={14}>
            <Card style={{ background: "#F5F5F5", border: "none" }}>
              <p className="text-3xl mb-4  font-medium	">Forgot Password</p>

              <Form
                form={form}
                name="normal_login"
                className="login-form"
                initialValues={{
                  remember: true,
                }}
                onFinish={validateLogin}
              >
                <Form.Item
                  className="mt-5"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your Email!",
                    },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined className="site-form-item-icon" />}
                    placeholder="Enter Your Email..."
                    type="email"
                  />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    loading={API?.isLoading}

                  >
                    Send
                  </Button>
                </Form.Item>

                <Link to={loginRoot}>
                  Sign in
                </Link>
              </Form>
              <div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default ForgetPass;
